import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { storage, useRequest } from "../../utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const AddProduct = (props) => {
  const [title, setTitle] = useState("");
  const [category_id, set_category_id] = useState("");
  const [sub_category_id, set_sub_category_id] = useState("");
  const [type_id, set_type_id] = useState("");
  const [brand_id, set_brand_id] = useState("");
  const [content_img, set_content_img] = useState("");
  const [property, set_property] = useState([]);
  const [size, set_size] = useState("");
  const [price, set_price] = useState(0);
  const [discount, set_discount] = useState(0);

  let history = useHistory();

  const sendData = () => {
    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });

    const formData = new FormData();

    formData.append("logo_img", content_img);
    formData.append("title", title);
    formData.append("category_id", category_id);
    formData.append("sub_category_id", sub_category_id);
    formData.append("type_id", type_id);
    formData.append("brand_id", brand_id);
    formData.append("property", JSON.stringify(property));
    formData.append("size", size);
    formData.append("price", price);
    formData.append("discount", discount);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/add_product", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          console.log(res);
          $.unblockUI();
          history.push("/dashboard/getProducts");
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  const [
    get_sub_categories_error,
    get_sub_categories_loading,
    get_sub_categories_data,
    get_sub_categories_function,
  ] = useRequest({
    method: "get",
    url: "/get_sub_categories",
  });

  const [
    get_categories_error,
    get_categories_loading,
    get_categories_data,
    get_categories_function,
  ] = useRequest({
    method: "post",
    url: "/get_categories_by_sub_category_id",
    // body: {
    //   sub_category_id,
    // },
  });

  const [
    get_types_error,
    get_types_loading,
    get_types_data,
    get_types_function,
  ] = useRequest({
    method: "post",
    url: "/get_types_by_category_id",
    // body: {
    //   sub_category_id,
    // },
  });

  console.log(property);

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">افزودن محصول جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن محصول جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              {get_sub_categories_data ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>دسته بندی اصلی</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={sub_category_id}
                                        onChange={(e) => {
                                          set_sub_category_id(e.target.value);
                                          set_category_id("");
                                          get_categories_function({
                                            sub_category_id: e.target.value,
                                          }).then(() => null);
                                        }}
                                      >
                                        <option selected value="">
                                          دسته بندی اصلی را انتخاب کنید
                                        </option>
                                        {get_sub_categories_data.data.map(
                                          (i) => (
                                            <option value={i._id}>
                                              {i.title}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {get_categories_data && sub_category_id ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>دسته بندی</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={category_id}
                                        onChange={(e) => {
                                          set_category_id(e.target.value);
                                          set_type_id("");
                                          get_types_function({
                                            category_id: e.target.value,
                                          }).then(() => null);
                                        }}
                                      >
                                        <option selected value="">
                                          دسته بندی را انتخاب کنید
                                        </option>
                                        {get_categories_data.data.map((i) => (
                                          <option value={i._id}>
                                            {i.title}
                                          </option>
                                        ))}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {get_types_data && category_id ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>نوع ها</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={type_id}
                                        onChange={(e) => {
                                          set_brand_id("");
                                          set_type_id(e.target.value);
                                        }}
                                      >
                                        <option selected value="">
                                          نوع را انتخاب کنید
                                        </option>
                                        {get_types_data.data.map((i) => (
                                          <option value={i._id}>
                                            {i.title}
                                          </option>
                                        ))}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}

                              {get_types_data && category_id && type_id ? (
                                <div class="row">
                                  <div class="col-md-6">
                                    <h6>برند ها</h6>
                                    <fieldset class="form-group">
                                      <select
                                        class="custom-select"
                                        id="customSelect"
                                        value={brand_id}
                                        onChange={(e) =>
                                          set_brand_id(e.target.value)
                                        }
                                      >
                                        <option selected value="">
                                          برند را انتخاب کنید
                                        </option>
                                        {(
                                          (
                                            (Array.isArray(get_types_data.data)
                                              ? get_types_data.data
                                              : []
                                            ).find(
                                              (i) =>
                                                String(i._id) ===
                                                String(type_id)
                                            ) || {}
                                          ).brand_ids || []
                                        )
                                          .filter((i) => i && i._id)
                                          .map((i) => (
                                            <option value={i._id} key={i._id}>
                                              {i.title}
                                            </option>
                                          ))}
                                      </select>
                                    </fieldset>
                                  </div>
                                </div>
                              ) : null}
                              {get_types_data && type_id && brand_id ? (
                                <>
                                  <h6>عنوان محصول</h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="عنوان محصول "
                                      value={title}
                                      onChange={(e) => setTitle(e.target.value)}
                                    />
                                  </div>
                                  <h6>سایز محصول </h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="سایز محصول "
                                      value={size}
                                      onChange={(e) => set_size(e.target.value)}
                                    />
                                  </div>

                                  {/* <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="عنوان محصول "
                                      value={property}
                                      onChange={(e) => set_property(e.target.value)}
                                    />
                                  </div> */}
                                  <h6>مبلغ محصول </h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="number"
                                      class="form-control"
                                      placeholder="مبلغ محصول "
                                      value={price}
                                      onChange={(e) =>
                                        set_price(e.target.value)
                                      }
                                    />
                                  </div>
                                  <h6>درصد تخفیف محصول </h6>

                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="number"
                                      class="form-control"
                                      placeholder="مبلغ تخفیف محصول "
                                      value={discount}
                                      onChange={(e) =>
                                        set_discount(e.target.value)
                                      }
                                    />
                                  </div>
                                  <div
                                    style={{
                                      padding: "10px",
                                      border: "1px solid rgba(0,0,0,0.2)",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <button
                                      onClick={() => {
                                        set_property((v) => [
                                          ...v,
                                          {
                                            title: null,
                                            description: null,
                                          },
                                        ]);
                                      }}
                                      style={{
                                        width: "fit-content",
                                      }}
                                      type="button"
                                      class="btn btn-success mr-1 mb-1 "
                                    >
                                      افزودن آیتم جدید
                                    </button>
                                    {property.map((i, index) => {
                                      return (
                                        <>
                                          <h6>عنوان آیتم</h6>

                                          <div
                                            style={{
                                              display: "flex",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="عنوان آیتم"
                                              value={i.title}
                                              onChange={(e) =>
                                                set_property((v) =>
                                                  v.map((m, m_index) =>
                                                    m_index === index
                                                      ? {
                                                          title: e.target.value,
                                                          description:
                                                            m.description,
                                                        }
                                                      : m
                                                  )
                                                )
                                              }
                                            />
                                          </div>
                                          <h6>توضیحات آیتم</h6>

                                          <div
                                            style={{
                                              display: "flex",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="توضیحات آیتم "
                                              value={i.description}
                                              onChange={(e) =>
                                                set_property((v) =>
                                                  v.map((m, m_index) =>
                                                    m_index === index
                                                      ? {
                                                          title: m.title,
                                                          description:
                                                            e.target.value,
                                                        }
                                                      : m
                                                  )
                                                )
                                              }
                                              // onChange={(e) =>
                                              //   setTitle(e.target.value)
                                              // }
                                            />
                                          </div>
                                          <button
                                            onClick={() =>
                                              set_property((v) =>
                                                v.filter(
                                                  (m, m_index) =>
                                                    m_index !== index
                                                )
                                              )
                                            }
                                            class="btn btn-icon btn-danger"
                                            style={{
                                              marginRight: "10px",
                                            }}
                                            type="button"
                                            data-repeater-delete
                                          >
                                            <span
                                              style={{
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              حذف آیتم
                                            </span>
                                          </button>
                                        </>
                                      );
                                    })}
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <fieldset>
                                        <h6>اپلود تصویر</h6>
                                        <div class="input-group">
                                          <div class="input-group-prepend"></div>
                                          <div class="input-group">
                                            <div class="custom-file">
                                              <input
                                                type="file"
                                                class="custom-file-input"
                                                id="inputGroupFile02"
                                                onChange={(e) =>
                                                  set_content_img(
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <label
                                                class="custom-file-label"
                                                for="inputGroupFile02"
                                                aria-describedby="inputGroupFileAddon02"
                                              >
                                                {content_img
                                                  ? content_img.name
                                                  : "انتخاب فایل"}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {get_types_data && type_id ? (
                <button
                  onClick={() => {
                    sendData();
                  }}
                  style={{
                    marginTop: "-2rem",
                    marginRight: "25px",
                    width: "fit-content",
                  }}
                  type="button"
                  class="btn btn-success mr-1 mb-1 "
                >
                  افزودن محصول جدید
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { AddProduct };
